import BaseAPI from "./BaseAPI";
import { menuRoute } from "../routes";

export default class MenuAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, menuRoute, "menu");
    }

    async Update(id, data, revision) {
        return super.Update(id, { ...data, revision });
    }

    async Publish(id) {
        const result = await this._request("put", this._url(`/${id}/publication`), {});
        this._emit("update", id);
        return result;
    }

    async Unpublish(id) {
        const result = await this._request("delete", this._url(`/${id}/publication`));
        this._emit("update", id);
        return result;
    }
}
